declare global {
  interface Window {
    Calendly: {
      showPopupWidget: (url: string) => void;
    };
  }
}

interface IGetActualYearAndMonth {
  year: number;
  month: string;
}

const injectCalendlyScriptDynamically = (onLoadCallback: () => void): void => {
  const CALENDLY_SCRIPT_URL =
    "https://assets.calendly.com/assets/external/widget.js";
  const script = document.createElement("script");

  script.src = CALENDLY_SCRIPT_URL;
  script.async = true;
  script.defer = true;
  script.onload = onLoadCallback;
  document.head.appendChild(script);
};

const getBookConsultationUrlWithParams = (): string => {
  const baseUrl = process.env.VUE_APP_CALENDLY_BOOK_CONSULTATION_LINK;
  const { year, month } = getActualYearAndMonth();

  const queryParams = new URLSearchParams({
    back: "1",
    month: `${year}-${month}`,
  });

  return `${baseUrl}?${queryParams.toString()}`;
};

const getActualYearAndMonth = (): IGetActualYearAndMonth => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");

  return { year, month };
};

export const openBookConsultationPopup = (): void => {
  const url = getBookConsultationUrlWithParams();

  if (window.Calendly) {
    window.Calendly.showPopupWidget(url);
    return;
  }

  injectCalendlyScriptDynamically(() => window.Calendly.showPopupWidget(url));
};
